import React from 'react';
import { LineUp } from '../models/match-live-data';
import { getFormationPositions } from '@/models/formations';
import { H6, P } from './text';
import Image from 'next/image';
import { Table, TableBody, TableCell, TableRow } from './table';
import config from '@/lib/config';
import Link from 'next/link';

const MatchLineup: React.FC<{ homeLineup: LineUp; awayLineup: LineUp }> = ({ homeLineup, awayLineup }) => {
	const homeFormationUsed = homeLineup.formationUsed;
	const awayFormationUsed = awayLineup.formationUsed;

	const homeFormation = getFormationPositions(homeFormationUsed);
	const awayFormation = getFormationPositions(awayFormationUsed);

	if (!homeFormation || !awayFormation) {
		return <div>Nog geen opstelling beschikbaar</div>;
	}

	const homeFormationPlayers = homeLineup.player
		?.filter((player) => player.formationPlace)
		?.map((player, index) => {
			const position = homeFormation[index];
			const imagePath = `${config.doAssetUrl}/shirts/2025-2026/${homeLineup.contestantId}.png`;

			return (
				<div
					key={player.playerId}
					className="absolute z-10 flex gap-1 -translate-x-1/2"
					style={{ left: `${position.x}%`, top: `${position.y}%` }}
				>
					<div className="shirt flex flex-col justify-center items-center">
						<Image
							src={imagePath}
							width={28}
							height={28}
							alt={player.matchName}
							className="hidden sm:block md:hidden lg:block"
						/>
						<div className="flex items-center gap-x-1">
							<span className="text-xs text-black-800 opacity-80 font-semibold">
								{player.shirtNumber}.
							</span>
							<Link href={`/spelers/${player.playerPostUrl}`}>
								<span className="text-xs text-black-800  opacity-80 font-semibold text-balance">
									{player.shortLastName}
								</span>
							</Link>
						</div>
					</div>
				</div>
			);
		});

	const awayFormationPlayers = awayLineup.player
		?.filter((player) => player.formationPlace)
		?.map((player, index) => {
			const position = awayFormation[index];

			const imagePath = `${config.doAssetUrl}/shirts/2025-2026/${awayLineup.contestantId}.png`;

			return (
				<div
					key={player.playerId}
					className="absolute z-10 flex gap-1 -translate-x-1/2"
					style={{ left: `${100 - position.x}%`, top: `${100 - position.y}%` }}
				>
					<div className="shirt flex flex-col justify-center items-center">
						<Image
							src={imagePath}
							width={28}
							height={28}
							alt={player.matchName}
							className="hidden sm:block md:hidden lg:block"
						/>
						<div className="flex items-center gap-x-1">
							<span className="text-xs text-black-800 opacity-80 font-semibold">
								{player.shirtNumber}.
							</span>
							<Link href={`/spelers/${player.playerPostUrl}`}>
								<span className="text-xs text-black-800  opacity-80 font-semibold text-nowrap">
									{player.shortLastName}
								</span>
							</Link>
						</div>
					</div>
				</div>
			);
		});

	const homeBenchPlayers = homeLineup.player
		?.filter((player) => !player.formationPlace)
		?.map((player) => (
			<TableRow key={player.playerId} className="even:bg-gray-50">
				<TableCell className="!text-right">
					<Link href={`/spelers/${player.playerPostUrl}`} className="text-sm !uppercase !font-bold">
						{player.matchName}
					</Link>
				</TableCell>
				<TableCell className="w-4">
					<P className="text-sm !uppercase !font-bold">{player.shirtNumber}</P>
				</TableCell>
			</TableRow>
		));

	const awayBenchPlayers = awayLineup.player
		?.filter((player) => !player.formationPlace)
		?.map((player) => (
			<TableRow key={player.playerId} className="even:bg-gray-50">
				<TableCell className="w-4">
					<P className="text-sm text-left capitalize !font-semibold">{player.shirtNumber}</P>
				</TableCell>
				<TableCell>
					<Link href={`/spelers/${player.playerPostUrl}`} className="text-sm !uppercase !font-bold">
						{player.matchName}
					</Link>
				</TableCell>
			</TableRow>
		));

	return (
		<div className="md:grid md:grid-cols-4 md:gap-8 mb-8 ">
			<div className="my-8 md:my-0">
				<H6 className="text-right pb-2">Wissels</H6>
				<Table snug>
					<TableBody className="bg-white">{homeBenchPlayers}</TableBody>
				</Table>
			</div>
			<div className="w-full aspect-[2/3] relative md:col-span-2">
				{homeFormationPlayers}
				{awayFormationPlayers}
				<div className="soccerfield absolute top-0 left-0 z-[9] translate-y-4 xl:translate-y-6 opacity-80 md:opacity-100">
					<Image src="/images/soccerfield.png" alt="Soccerfield" width={800} height={1211} />
				</div>
			</div>
			<div className="my-8 md:my-0">
				<H6 className="text-left pb-2">Wissels</H6>
				<Table snug>
					<TableBody className="bg-white">{awayBenchPlayers}</TableBody>
				</Table>
			</div>
		</div>
	);
};

export default MatchLineup;
